import { CreatedInterfaces } from '../interfaces';
import { getErrorMessage } from '../utils/errorCodes';
import { usePostRequest } from './utils/usePostRequest';

const resource = 'card-product-create'

const useCreateCardProduct = () => {
  const [{ data, error, loading }, createCardProduct] = usePostRequest<CreatedInterfaces<typeof resource>>({
    path: 'v1/card_products'
  });

  return {
    cpLoading: loading,
    // @ts-ignore
    cpError: getErrorMessage(error?.response?.data?.errors && error?.response?.data?.errors[0]?.message),
    createCardProduct,
    cardProduct: data
  };
}
export default useCreateCardProduct;